import { get } from '../base';

import { UserInvitationsResponse } from './types-get-user-invitations';

export function getUserInvitations(): Promise<UserInvitationsResponse> {
  return get(`v5/user/invitations`).json();
}
